import React, { useState, useRef, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./Topbar";
import Leftbar from "./Sidebar";
import Dashboard from "../features/dashboard/dashboard";
import DashboardReport from "../features/dashboard/dashboardreport";
import UserSubscription from "../features/subscription/usersubscription";
import UserProfile from "../features/users/userprofile";
import UserPreference from "../features/users/userpreference";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../assets/theme";
import FolderDashboard from '../features/folderDashboard/folderdashboard';
import IdleTimer from 'react-idle-timer';
import IdleTimerDialog from './IdleTimerDialog';
import { useLogoutMutation, usePbiGetRefreshSessionMutation } from '../features/auth/authApiSlice'
import { setPBIReportList, setSelectedReportDetails, setSelectedReportId, setTenantWorkspace, setTenantWorkspacelist } from '../features/auth/authSlice'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux"

function Layout() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [idlePopup, setIdlePopup] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [logout, { isLoading }] = useLogoutMutation()
  const [refreshSession, { isrefreshLoading}] = usePbiGetRefreshSessionMutation()

  const idleTimerRef = useRef(null);
  const sessionTimeoutRef = useRef(null);

  // const handleRefreshSession = async () => {
  //   try {
  //     const refreshresponse = await refreshSession().unwrap();
  //     console.log('refreshresponse', refreshresponse)
  //   } catch (err) {
  //     console.log('err', err);
  //   }
  // }
  // useEffect(() => {
  //   const interaval = setInterval(handleRefreshSession, 1000 * 60 * 30);
  //   return () => clearInterval(interaval);
  // }, [])

  const handleStayLogIn = () => {
    console.log('staylogin')
    setRefresh(prevKey => prevKey + 1)
    setIdlePopup(false);
    if (idleTimerRef.current) {
      idleTimerRef.current.reset();
      clearTimeout(sessionTimeoutRef.current);
    }
  }

  const handleLogout = async () => {
    let emptyreports = [];
    try {
      closePopup();
      const logoutresponse = await logout().unwrap()
      dispatch(setPBIReportList(emptyreports))
      dispatch(setSelectedReportDetails(null))
      dispatch(setSelectedReportId(null))
      dispatch(setTenantWorkspace(null))
      dispatch(setTenantWorkspacelist([]))
      localStorage.removeItem('userData');
      sessionStorage.removeItem('sessionStartTime');
      navigate('/')
    } catch (err) {
      console.log(err);
    }
  }

  const handleOnIdle = event => {
    setIdlePopup(true);
    console.log('user is idle', event)
    sessionTimeoutRef.current = setTimeout(handleLogout, 1000 * 60 * 1); // 1 minute
    console.log('sessionTimeoutRef', sessionTimeoutRef)
  };

  const closePopup = () => {
    setIdlePopup(false);
    setRefresh(0)
    // Reset the idle timer
    if (idleTimerRef.current) {
      idleTimerRef.current.reset();
      clearTimeout(sessionTimeoutRef.current);
    }
  };

  useEffect(() => {
    // Check if the session start time is stored in localStorage
    const sessionStartTime = sessionStorage.getItem('sessionStartTime');
    const TEN_HOURS = 10 * 60 * 60 * 1000;
    if (sessionStartTime) {
      const interval = setInterval(() => {
        const currentTime = Date.now();
        const elapsedTime = currentTime - sessionStartTime;
        const remainingTime = TEN_HOURS - elapsedTime;

        if (remainingTime <= 0) {
            console.log('Session expired. Logging out...');
            clearInterval(interval); // Clear the interval
            handleLogout(); // Log out the user
        } 
    }, 1000); 

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
    }
  }, []);

  return (
    <React.Fragment>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {/* <ProSidebarProvider> */}
          <div className="app">
            <Leftbar isSidebar={isSidebar} />
            <main className="content">
              <Topbar setIsSidebar={setIsSidebar} />
              <IdleTimer
                key={refresh}
                ref={idleTimerRef}
                timeout={1000 * 60 * 15} // 15 minutes  1000 * 60 * 15
                onIdle={handleOnIdle}
                // onActive={handleOnActive}
                // onAction={handleOnAction}
              // debounce={500}
              >
                <Routes>
                  <Route path="" element={<Dashboard />} />
                  <Route path="dashboardreport" element={<DashboardReport />} />
                  <Route path="usersubscription" element={<UserSubscription />} />
                  {/* <Route path="folderdashboard" element={<FolderDashboard />} /> */}
                  <Route path="userprofile" element={<UserProfile />} />
                  <Route path="userpreference" element={<UserPreference />} />
                </Routes>
              </IdleTimer>
            </main>
          </div>
          {/* </ProSidebarProvider> */}
        </ThemeProvider>
      </ColorModeContext.Provider>
      {idlePopup ? <IdleTimerDialog open={idlePopup} onClose={closePopup}
        logout={handleLogout} staylogin={handleStayLogIn} /> : null}
    </React.Fragment>
  );
}

export default Layout;
